import type { IconSvgObject } from './types';

const Rotate02Icon: IconSvgObject = [
  ["path", { d: "M20.0007 2.5V6C18.1763 3.57111 15.2716 2 12 2C6.47715 2 2 6.47715 2 12C2 15.9582 4.2997 19.3793 7.63587 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.3626 22C11.9004 22 11.4455 21.9695 11 21.9106M21.7373 9C21.8486 9.38726 21.9359 9.77865 22 10.1722M21.9658 13.7496C21.8962 14.1396 21.8055 14.5258 21.6946 14.9063M20.1854 18.0963C19.9495 18.4409 19.6937 18.7726 19.419 19.0892M16.6257 21.3767C16.2755 21.574 15.9111 21.7526 15.533 21.9106", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Rotate02Icon;
